import { useTranslation } from "react-i18next";
import { Aside } from "../../../components/layout/Aside";
import { useBookContext } from "../bookContext";
import { BookFactsCard } from "./BookFactsCard";
import { ChaptersCard } from "./ChaptersCard";
import { FailuresCard } from "./FailuresCard";
import { GuidedWorkspace } from "./GuidedWorkspace";
import { SpendCard } from "./SpendCard";

/**
 * The Book page DESIGN keeps referring to and the mockups never drew: every
 * Chapter with its state, size, cost, and audio, what the Book has spent, and
 * whatever is waiting for a retry. Reached from the Book title in the nav and
 * from /books/:id when the Book has Failed.
 */
export function Overview() {
  const { t } = useTranslation(["overview", "states"]);
  const { book } = useBookContext();
  // Approval is what the Author did, and it survives the render: counting
  // `counts.approved` alone would read "0 chapters are approved" on a Book
  // whose every Chapter is already rendered.
  const approved = book.chapters.filter(
    (chapter) => !chapter.excluded && chapter.approvedAt !== null,
  ).length;
  // A Book whose Chapters have not been proposed yet has nothing to count, and
  // "0 Kapitel sind freigegeben" next to an empty table reads as a loss.
  const hasChapters = book.chapters.length > 0;
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-4">
      <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
        <h1 className="font-serif text-title font-semibold">{t("overview:title")}</h1>
        {hasChapters ? (
          <p className="font-mono text-label text-ink-2">
            {t("states:chaptersApproved", { count: approved })}
          </p>
        ) : null}
      </div>
      <GuidedWorkspace />
      <div className="flex min-w-0 flex-col items-start gap-6 xl:flex-row">
        <div className="w-full min-w-0 flex-1">
          <ChaptersCard />
        </div>
        <Aside className="order-first min-w-0 max-xl:w-full xl:order-none">
          <BookFactsCard />
          <FailuresCard />
          <SpendCard />
        </Aside>
      </div>
    </div>
  );
}
